export class Dashboard {
  constructor () {
    this.skills = 0
    this.trainings = 0
    this.yoe = 0
    this.packages = 0
    this.recommendedPackages = []
  }
}



// WEBPACK FOOTER //
// ./src/models/Dashboard.js